import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

const UploadImagesInput = ({ onChange }) => {
  // eslint-disable-next-line no-unused-vars
  const [images, setImages] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [previewUrls, setPreviewUrls] = useState(null);
  const { t } = useTranslation();

  const handleImagesChange = (event) => {
    if (event.target.files) {
      const selectedImages = Array.from(event.target.files);
      setImages(selectedImages);

      const blob = selectedImages.map((image) => URL.createObjectURL(image));
      setPreviewUrls(blob);

      onChange(selectedImages)
    }
  };


  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item>
        <input
          accept="image/*"
          id="images-input"
          type="file"
          multiple
          onChange={handleImagesChange}
          style={{ display: 'none' }}
          />
        <label htmlFor="images-input">
          <Box sx={{ border: 1, borderRadius: '10px', borderColor: '#bdbdbd', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5rem' }}>
            <Typography htmlFor="pic-input" sx={{ fontWeight: 'bold', marginBottom: '1rem', color: '#808080' }}>{t('newOutfit.addPhotos')}</Typography>
            <AddIcon sx={{ color: '#808080' }} />
          </Box>
        </label>
      </Grid>
    </Grid>
  );
};

export default UploadImagesInput;
